var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLampOuter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 546,
    viewBox: "0 0 379 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.394 3.32409C93.2381 -3.42536 2.72169 83.3101 3.12488 189.992C3.32647 246.405 28.7276 296.875 68.5427 330.924C101.907 359.332 120.554 401.34 120.554 445.161C120.554 447.78 122.772 449.896 125.393 449.896H255.019C256.833 449.896 258.446 448.385 258.446 446.571V445.161C258.446 400.736 278.202 358.929 311.667 329.816C350.273 296.27 374.968 247.211 375.875 192.309C377.488 93.3839 300.176 9.46911 201.394 3.32409Z",
    stroke: "#0B4769",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.252 478.103H242.822C251.692 478.103 258.849 485.255 258.849 494.12V495.732C258.849 504.597 251.692 511.749 242.822 511.749H136.178C127.308 511.749 120.151 518.901 120.151 527.766C120.151 536.631 127.308 544.992 136.178 544.992H379",
    stroke: "#0B4769",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampOuter);
export default __webpack_public_path__ + "static/media/lamp-outer.2439948dd932f2f15fd09961e404b4f2.svg";
export { ForwardRef as ReactComponent };